import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-tft-solo-divisions',
  templateUrl: './tft-divisions.component.html'
})
export class TftDivisionsComponent {
  service = 'divisions';
  availableServices = services['tft'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'tft',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Division Boosting',
    },
    subtitle: {
      en: 'Achieve Your Goals With Our Expert TFT Boosting Services',
      fr: 'Atteins tes objectifs avec nos services spécialisés de boost TFT',
      de: 'Erreiche deine Ziele mit unseren spezialisierten TFT-Boosting-Diensten',
      pt: 'Alcança os teus objetivos com os nossos serviços especializados de boost TFT',
      es: 'Alcanza tus objetivos con nuestros servicios especializados de boost TFT',
    },
    start: DivisionsService.getValueByRank('Silver I', 'tft'),
    desired: DivisionsService.getValueByRank('Gold IV', 'tft')
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Division Elo Boost?",
        answer: "Teamfight Tactics Elo Boosting can take the form of a Division Boost, which guarantees that the player will achieve the desired rank."
      },
      {
        question: "What If You Demote During The Service?",
        answer: "We promise to deliver the contracted service. Therefore, if something like that were to occur, we would go beyond it and finish the service as planned."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "May I Get Advice on the Current TFT Meta?",
        answer: "Absolutely. In the order chat, you can ask your booster for advice on how to improve your current meta knowledge."
      },
      {
        question: "Can I Purchase Division Before My Placements Are Complete?",
        answer: "Only accounts with all placements completed are eligible for Division Boost."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost d\'Elo de Division?",
        answer: "Le Boosting d\'Elo Teamfight Tactics peut prendre la forme d\'un Boost de Division, qui garantit que le joueur atteindra le rang désiré."
      },
      {
        question: "Que se passe-t-il si vous êtes rétrogradé ou si vous perdez la série de promotions?",
        answer: "Nous nous engageons à fournir le service contracté. Par conséquent, si une telle chose devait se produire, nous irions au-delà et terminerions le service comme prévu."
      },
      {
        question: "Puis-je jouer pendant que la commande est active ?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je obtenir des conseils sur la Meta TFT actuel?",
        answer: "Absolument. Dans le chat de commande, vous pouvez demander à votre booster des conseils sur la façon d\'améliorer vos connaissances actuelles de la méta."
      },
      {
        question: "Puis-je acheter une division avant la fin de mon placement?",
        answer: "Seuls les comptes dont toutes les parties de placements sont terminés sont éligibles au Boost de Division."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Division Elo Boost?",
        answer: "Teamfight Tactics Elo-Boosting kann in Form eines Division-Boosts erfolgen, der garantiert, dass der Spieler den gewünschten Rang erreicht."
      },
      {
        question: "Was passiert, wenn du degradierst, bevor der Dienst beendet ist?",
        answer: "Wir versprechen, die vertraglich vereinbarte Leistung zu erbringen. Sollte dies der Fall sein, so werden wir über unsere Verpflichtungen hinausgehen und den Dienst planmäßig zu Ende führen."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich einen Ratschlag zum aktuellen TFT Meta bekommen?",
        answer: "Auf jeden Fall. Im Bestellungschat kannst du deinen Booster um Rat fragen, wie du dein aktuelles Metawissen verbessern kannst."
      },
      {
        question: "Kann ich eine Division kaufen, bevor meine Platzierungen abgeschlossen sind?",
        answer: "Nur Konten, bei denen alle Platzierungen abgeschlossen sind, sind für Division Boost geeignet."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Division Elo Boost?",
        answer: "Um Division Boost em TFT significa que um jogador profissional ajuda-te a subir de rank jogando na tua conta."
      },
      {
        question: "O Que Acontece Se Eu For Despromovido No Decorrer do Serviço?",
        answer: "Nós comprometemo-nos a concluir o serviço com sucesso. Portanto, se algo assim acontecer, iremos cumprir o serviço conforme planeado."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso Obter Conselhos Sobre O Meta Actual De TFT?",
        answer: "Sim. No chat do serviço podes pedir conselhos ao booster de forma a melhorar o teu conhecimento actual do meta."
      },
      {
        question: "Posso Comprar Division Boosting Antes De Completar Os Meus Placements?",
        answer: "Não. Apenas contas com todas os placements completos são elegíveis para Division Boost."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un Division Elo Boost?",
        answer: "Teamfight Tactics Elo Boosting puede tomar la forma de un Division Boost, que garantiza que el jugador alcanzará el rango deseado."
      },
      {
        question: "¿Qué pasa si descendeis de categoría o perdeis la serie de ascensos?",
        answer: "Nos comprometemos a prestar el servicio contratado. Por lo tanto, si ocurriera algo así, iríamos más allá y terminaríamos el servicio según lo previsto."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo recibir asesoramiento sobre el actual TFT Meta?",
        answer: "Por supuesto. En el chat de órdenes, puedes pedir consejo a tus boosters sobre cómo mejorar tu meta conocimiento actual."
      },
      {
        question: "¿Puedo comprar División antes de que se completen mis clasificaciones?",
        answer: "Sólo las cuentas con todas las clasificaciones completadas pueden optar al Division Boost."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      "en": "TFT Boost - Premium Boosting for Teamfight Tactics",
      "fr": "TFT Boost - Boosting Premium pour Teamfight Tactics",
      "de": "TFT Boost - Premium Boosting für Teamfight Tactics",
      "pt": "Boost TFT - Boosting Premium para Teamfight Tactics",
      "es": "TFT Boost - Boosting Premium pour Teamfight Tactics",
    },
    metaDescription: {
      "en": "Rank up swiftly in Teamfight Tactics with GGBoost. Opt for our Elite and Trustworthy boosting services, ensuring Dominant Gameplay round after round",
      "fr": "Montez rapidement en rang dans Teamfight Tactics avec GGBoost. Optez pour nos services de boosting élite et fiables, garantissant un gameplay dominant tour après tour.",
      "de": "Steige mit GGBoost schnell in den Teamfight Tactics auf. Entscheide dich für unseren zuverlässigen Elite-Boosting-Service, der dir Runde für Runde ein dominantes Gameplay garantiert.",
      "pt": "Suba rapidamente de nível no Teamfight Tactics com GGBoost. Opte pelos nossos serviços de boosting Elite e Confiáveis, garantindo um Gameplay Dominante ronda após ronda.",
      "es": "Montez rapidement en grade sur Teamfight Tactics avec GGBoost. Optez pour nos services de boosting d\'élite et de confiance, garantissant un gameplay dominant manche après manche.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}